@let s = summary();
@let p = paths();
<div class="top">
  <span class="label">{{ label() }}</span>
  <span class="value" [class]="'tone-' + tone()">{{ current() }}</span>
</div>
<svg class="graph" viewBox="0 0 100 32" preserveAspectRatio="none" aria-hidden="true">
  @if (p) {
    @if (p.cap) {
      <path class="cap" [attr.d]="p.cap" />
    }
    <path class="raw" [class]="'tone-' + tone()" [attr.d]="p.raw" />
    <path class="avg" [attr.d]="p.avg" />
  }
</svg>
<div class="bottom">
  <span>Ø {{ s?.avg ?? '–' }}</span>
  <span>{{ s ? s.min + '–' + s.max : '' }}</span>
</div>
